import { actionStringGenerator, createPayloadAction } from '../helpers';
import { StandardAction } from '../types';
import { FetchCurrentUserSuccessPayload, FetchUserPayload } from './types';

export default class UserAction {
  static TYPES = {
    // Async actions
    // -- Fetch user
    FETCH_USER: actionStringGenerator('user', 'FETCH_USER'),
    UPDATE_USER: actionStringGenerator('user', 'UPDATE_USER'),
    CLEAR_USER: 'CLEAR_USER',
  };

  // Fetch user
  static fetchUserStart = (payload: FetchUserPayload): StandardAction<FetchUserPayload> =>
    createPayloadAction(UserAction.TYPES.FETCH_USER.START, payload);

  static fetchUserSuccess = (
    payload?: FetchCurrentUserSuccessPayload,
  ): StandardAction<FetchCurrentUserSuccessPayload> =>
    createPayloadAction(UserAction.TYPES.FETCH_USER.SUCCESS, payload);

  static fetchUserError = (error?: string): StandardAction =>
    createPayloadAction(UserAction.TYPES.FETCH_USER.FAILURE, undefined, undefined, error);

  // Update user - placeholder => type: any
  static updateUserStart = (payload: any): StandardAction<any> =>
    createPayloadAction(UserAction.TYPES.UPDATE_USER.START, payload);

  static updateUserSuccess = (payload: any): StandardAction<any> =>
    createPayloadAction(UserAction.TYPES.UPDATE_USER.SUCCESS, payload);

  static updateUserError = (error?: string): StandardAction =>
    createPayloadAction(UserAction.TYPES.UPDATE_USER.FAILURE, undefined, undefined, error);

  static clearUser = (): StandardAction => createPayloadAction(UserAction.TYPES.CLEAR_USER);
}
